import { IStore } from '@/store/types';
import { IDialogType, IModuleState } from './types';
import * as actions from './actions';
import * as mutations from './mutations';

const initialState = {
  list: { data: [], loading: false },
  detail: { data: null, loading: false },
  options: { data: [], loading: false },
  dialog: { data: null, title: '', type: '' as IDialogType, visible: false, loading: false },
  confirm: { title: '', content: '', visible: false, loading: false },
  loading: false,
};

export default { namespaced: true, state: initialState, actions, mutations } as IStore<IModuleState>;
